import api, { api_v2 } from "@/api/axios.config"
import type { MentoresType, MentoriaDataType } from "@/types/mentorias"

export interface MentoringRateData {
	mentoria_id: number
	emp_id: number
	mentorado_id?: number
	mentorado_avaliacao?: number
	mentorado_observacao?: string
}

export interface PendingMentoringsRateResponse {
	mentoria_id: number
	data_hora_mentoria: string
	descricao_mentoria: string
	status_mentoria: number
	mentor_nome?: string
}

export const getMentores = async (
	company_id: number,
): Promise<{ data: { data: MentoresType[] } }> => {
	return api_v2.get(`/empresas/${company_id}/mentores`)
}

export const getMentorias = async (
	emp_id: number,
	params?: { status?: string },
): Promise<{ data: { data: MentoriaDataType[] } }> => {
	return api.get(`/mentorias/${emp_id}/mentorias`, { params })
}

export const getPendingFeedback = async (emp_id: number) => {
	return api.get(`/mentorias/${emp_id}/mentorias-pendentes`)
}

export const mentoringRate = async (payload: MentoringRateData) => {
	return api.post(`/mentorias/avalia-mentoria`, payload)
}

export const getPendingMentoringsRate = async (emp_id: number | string) => {
	return api.get<{ data: PendingMentoringsRateResponse[] }>(
		`/mentorias/${emp_id}/mentorias-pendentes`,
	)
}
